module.exports = require("@mui/material/Switch");